import React from "react";import {PlansScreen} from "@features/swing-trading/screens";export default function View():JSX.Element{return <PlansScreen mode="trades"/>}
